// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8bf86486","453":"26c0234d","455":"3fb61f55","977":"7fda816e"}[chunkId] + ".chunk.js";
};